export default __webpack_public_path__ + "assets/models/306b66be160bd6e2391a1b677f407cf3.glb";